













import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

const MAX_BALLS_COUNT = 5;

@Component({
  name: "AppBallsDisplay",
  data() {
    return {
      MAX_BALLS_COUNT: MAX_BALLS_COUNT
    };
  }
})
export default class AppBallsDisplay extends Vue {
  @Prop({ required: true }) goals: number;
  @Prop({ default: "medium" }) size: "small" | "medium";
}
